import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { Sprout } from 'lucide-react';

/**
 * IndexCard component - Designed for printing at standard 3x5 inch size
 * At 300 DPI (print quality): 900px × 1500px
 * This component renders at exact dimensions for screenshot and printing
 */
export default function IndexCard() {
  const qrCodeUrl = 'https://localartistfairs.com/welcome';

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 p-8">
      {/* Index Card Container - 3x5 inches at 300 DPI */}
      <div
        className="bg-white shadow-2xl relative overflow-hidden"
        style={{
          width: '900px',
          height: '1500px',
          border: '2px solid #e5e7eb',
        }}
      >
        {/* Content Container with padding */}
        <div className="flex flex-col items-center justify-between h-full p-16">
          {/* Header Section */}
          <div className="flex flex-col items-center text-center space-y-6">
            {/* Icon */}
            <div className="bg-primary-dark rounded-full p-8">
              <Sprout className="h-24 w-24 text-white" />
            </div>

            {/* Main Heading */}
            <h1 className="text-6xl font-bold text-primary-dark leading-tight">
              Your Artist Fair<br />Has Been Indexed!
            </h1>
          </div>

          {/* Branding */}
          <div className="flex flex-col items-center space-y-4">
            <div className="text-5xl font-bold text-teal-900">
              LocalFairs.com
            </div>
            <div className="h-1 w-48 bg-primary-dark"></div>
          </div>

          {/* QR Code Section */}
          <div className="flex flex-col items-center space-y-6 bg-white p-8 rounded-lg border-4 border-teal-800">
            <QRCodeSVG
              value={qrCodeUrl}
              size={280}
              level="H"
              includeMargin={true}
              bgColor="#ffffff"
              fgColor="#000000"
            />
            <div className="text-3xl font-semibold text-gray-700 text-center">
              Scan to learn more and<br />claim your listing
            </div>
          </div>

          {/* Footer Message */}
          <div className="text-center space-y-3">
            <p className="text-4xl font-medium text-primary-dark">
              Thank you for supporting<br />local agriculture!
            </p>
            <div className="flex items-center justify-center space-x-3 text-3xl text-gray-600">
              <Sprout className="h-10 w-10" />
              <span>Fresh • Local • Community</span>
              <Sprout className="h-10 w-10" />
            </div>
          </div>
        </div>

        {/* Decorative Corner Elements */}
        <div className="absolute top-0 left-0 w-32 h-32 border-t-8 border-l-8 border-teal-800 opacity-20"></div>
        <div className="absolute bottom-0 right-0 w-32 h-32 border-b-8 border-r-8 border-teal-800 opacity-20"></div>
      </div>
    </div>
  );
}
